import {Badge} from "../../basic/badge";
import {VwpLicense} from "../../../store/generated/api";
import {getLicenseDisplayStatus, getLicenseStatusBadgeVariant} from "../../../utils/licenseUtils";
import {useTranslationWithKeys} from "../../../hooks/useTranslationWithKeys";

interface LicenseStatusChipProps {
    license: VwpLicense;
    className?: string;
}

export function LicenseStatusChip({license, className = ""}: LicenseStatusChipProps) {
    const {t} = useTranslationWithKeys();
    const displayStatus = getLicenseDisplayStatus(license);
    const variant = getLicenseStatusBadgeVariant(displayStatus);

    return (
        <Badge variant={variant} className={`rounded-full ${className}`}>
            {t(`licenses.statusValues.${displayStatus}`)}
        </Badge>
    );
}
